export default __webpack_public_path__ + "static/media/photo--sm--kickoff3.2aa77b5f.jpg";